import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppSettingsService, SubdomainEnum } from 'src/app/services/app-settings.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UtilsService } from 'src/app/services/utils.service';
import UnitCardStatus from 'src/app/shared/enums/unit-card/UnitCardStatus.enum';
import { UnitFullName } from 'src/app/shared/models/unit-bank-account/UnitFullName.model';
import { TerraUtils } from 'src/app/shared/TerraUtils';

@Component({
  selector: 'terra-unit-card',
  templateUrl: './unit-card.component.html',
  styleUrls: ['./unit-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitCardComponent implements OnInit, OnChanges {

  @Input() cardId: number = 0;
  @Input() cardStatus: UnitCardStatus = UnitCardStatus.Active;
  @Input() holderFullName: UnitFullName = new UnitFullName('Joan', 'Smith');
  @Input() cardNumber: string = '1234';
  @Input() exp: string = '••••-••';
  @Input() cvv: string = '•••';
  @Input() viewSensitive: boolean = false;
  @Input() loadingSensitiveData: boolean = false;

  UnitCardStatus = UnitCardStatus;
  TerraUtils = TerraUtils;

  isLpSide = this.appSettingService.subDomain === SubdomainEnum.LP;

  constructor(
    private snackbarService: SnackbarService,
    private appSettingService: AppSettingsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.viewSensitive && !changes.viewSensitive.currentValue) {
      if (!!document.getElementById(`secured-cvv-${this.cardId}`))
        document.getElementById(`secured-cvv-${this.cardId}`).innerHTML = '•••';

      if (!!document.getElementById(`cvv-copy-button-${this.cardId}`))
        document.getElementById(`cvv-copy-button-${this.cardId}`).innerHTML = ``;

      if (!!document.getElementById(`secured-card-number-${this.cardId}`))
        document.getElementById(`secured-card-number-${this.cardId}`).innerHTML = `•••• •••• •••• ${this.cardNumber}`;

      if (!!document.getElementById(`card-number-copy-button-${this.cardId}`))
        document.getElementById(`card-number-copy-button-${this.cardId}`).innerHTML = ``;
    }
  }

  ngOnInit(): void {
    
  }

  get expDateFormat() {
    if(!this.viewSensitive){
      return '••/••'
    }
    return `${this.exp.substring(5, 7)}/${this.exp.substring(2, 4)}`;
  }

  snackbarMessage(itemName: string, e: Event) {
    if (!!itemName) {
      this.snackbarService.showGeneralMessage(`${itemName} was copied to the clipboard`, 1);
    }
    e.preventDefault();
  }

  get needOpacity(): boolean{
    return this.cardStatus === UnitCardStatus.Frozen || this.cardStatus === UnitCardStatus.ClosedByCustomer;
  }

}
